module.exports = __webpack_public_path__ + "static/media/WayToGo_Logo.0325c817.svg";